import React, { Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GlobalPointerEffects from "./components/GlobalPointerEffects";
import BackToTop from "./components/BackToTop";
import HomePage from "./pages/HomePage";
import { PrivacyPage, TermsPage, AccessibilityPage } from "./pages/LegalPages";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("SympTrack render error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main id="main" className="symp-container py-24 text-center">
          <h1 className="text-4xl font-extrabold text-brand-teal">
            Something went wrong.
          </h1>
          <p className="mt-4 text-lg text-brand-ink">
            Please refresh the page. If the problem continues, email us at
            symptrackhealth@gmail.com.
          </p>
        </main>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const reduce =
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
        }
      }, 60);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollManager />
        <a href="#main" className="skip-link" data-testid="skip-link">
          Skip to main content
        </a>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/accessibility" element={<AccessibilityPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <BackToTop />
        <GlobalPointerEffects />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
